import {NInputCalendarPopoverComponent} from "./n-input-calendar/n-input-calendar-popover/n-input-calendar-popover.component";
import {YearPickerComponent} from "./n-datepicker/yearpicker/yearpicker.component";
import {DatepickerHeaderComponent} from "./n-datepicker/datepicker-header/datepicker-header.component";
import {MonthPickerComponent} from "./n-datepicker/monthpicker/monthpicker.component";
import {DayPickerComponent} from "./n-datepicker/daypicker/daypicker.component";
import {DatePickerInnerComponent} from "./n-datepicker/datepicker-inner.component";
import {NDatePickerComponent} from "./n-datepicker/n-date-picker.component";
import {NButtonComponent} from "./n-button/n-button.component";
import {NInputComponent} from "./n-input/n-input.component";
import {NCheckboxComponent} from "./n-checkbox/n-checkbox.component";
import {NRadioComponent} from "./n-radio/n-radio.component";
import {NTextareaComponent} from "./n-textarea/n-textarea.component";
import {NIconComponent} from "./n-icon/n-icon.component";
import {NToggleComponent} from "./n-toggle/n-toggle.component";
import {NTabComponent} from "./n-tabset/n-tab/n-tab.component";
import {NTabsetComponent} from "./n-tabset/n-tabset.component";
import {NTimePickerComponent} from "./n-time-picker/n-time-picker.component";
import {NInputCalendarComponent} from "./n-input-calendar/n-input-calendar.component";
import {NControlGroupComponent} from "./n-control-group/n-control-group.component";
import {NHintComponent} from "./n-hint/n-hint.component";
import {NControlComponent} from "./n-control/n-control.component";
import {
  NDropdownDirective,
  NDropdownMenuComponent,
  NDropdownMenuDividerComponent,
  NDropdownMenuItemComponent, NDropdownMenuPopoverComponent,
} from "./dropdown/public_exports";
import {NDateTimePickerComponent} from "./n-date-time-picker/n-date-time-picker.component";
import {NSelectComponent} from "./n-select/n-select.component";
import {NOptionComponent} from "./n-select/n-option/n-option.component";
import {NGlobalStylesComponent} from "./global-styles/n-global-styles.component";

export const PUBLIC_COMPONENTS = [
  NButtonComponent,

  NInputComponent,

  NCheckboxComponent,
  NRadioComponent,
  NTextareaComponent,
  NSelectComponent,
  NOptionComponent,
  NIconComponent,
  NToggleComponent,
  NTabComponent,
  NTabsetComponent,
  NTimePickerComponent,
  NInputCalendarComponent,

  NControlGroupComponent,
  NHintComponent,
  NControlComponent,

  // dropdown:
  NDropdownDirective,
  NDropdownMenuComponent,
  NDropdownMenuDividerComponent,
  NDropdownMenuItemComponent,
  NDateTimePickerComponent,
  NDropdownMenuPopoverComponent,
  NGlobalStylesComponent,

  NDatePickerComponent
];

export const PRIVATE_COMPONENTS = [
  DatePickerInnerComponent,
  DayPickerComponent,
  MonthPickerComponent,
  DatepickerHeaderComponent,
  YearPickerComponent,
  NInputCalendarPopoverComponent,

];

export const ENTRY_COMPONENTS = [
  NInputCalendarPopoverComponent,
  NHintComponent,
  NDropdownMenuPopoverComponent
];
